/* tslint:disable */
/* eslint-disable */
/**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Edit } from "./edit";

/**
 *
 * @export
 * @interface UserEdit
 */
export interface UserEdit {
  /**
   *
   * @type {string}
   * @memberof UserEdit
   */
  id: string;
  /**
   *
   * @type {Array<Edit>}
   * @memberof UserEdit
   */
  edits: Array<Edit>;
  /**
   *
   * @type {string}
   * @memberof UserEdit
   */
  projectId: string;
}
